import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SectionComponent } from './section.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  declarations: [
    SectionComponent
  ],
  imports: [
    CommonModule,
    NgbModule
  ], 
  exports: [
    SectionComponent
  ]
})
export class SectionModule { }
